// @flow
import {observable} from 'mobx'

type Msg = {
  title: string,
  body?: string,
  onOk?: () => void,
  onAbort?: () => void
}

type Store = {
  msg: Msg | null,
  set: (msg:Msg) => void,
  close: () => void
}

const store:Store = observable(({
  msg: null,
  set: msg => {
    store.msg = msg
  },
  close: () => {
    store.msg = null
  }
}:Store))

export default store


// WEBPACK FOOTER //
// ./src/stores/alert.js